import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import app from './app'
import '../scss/index.scss'
import '../scss/only-dashboard.scss'
import Toasted from 'vue-toasted'
import $ from '../service/container'

import vuetify from '../plugins/vuetify'
import UniwebPlugin from "../plugins/uniweb"
import ScrollDetectPlugin from "../plugins/scrolldetect"
import VueApexCharts from "vue-apexcharts"
import VCalendar from 'v-calendar';

import EvaIcons from 'vue-eva-icons'
import Sticky from 'vue-sticky-directive';
import disable_all from "../directives/disable_all";

/**
 * App initialisation
 *
 * @namespace main
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/main.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

$.initiate(app);

Vue.prototype.$app = app
Vue.config.productionTip = false

const apolloProvider = app.apolloProvider

Vue.use(UniwebPlugin, {app})
Vue.use(ScrollDetectPlugin, {router})
Vue.use(EvaIcons)
Vue.use(Toasted, {
    duration: 3000,
    position: 'bottom-right'
})

Vue.use(VCalendar, {
    componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
})
Vue.use(VueApexCharts);

Vue.use(Sticky);
Vue.directive('disable-all', disable_all);

Vue.component('apexchart', VueApexCharts)

store.commit('buildStoreFromLocalStorage')

const lastRefresh = store.state.authToken && store.state.lastRefresh ? store.state.lastRefresh : null;
let loggedOut = false;

// If dashboard has been closed for longer than 5 minutes, logout.
if (lastRefresh) {
    const lastRefreshInSeconds = ((new Date()).getTime() - lastRefresh.getTime()) / 1000;

    if (lastRefreshInSeconds > 300) {
        store.dispatch('logout')
        loggedOut = true;
    }
}


// Load the local translations. (needed for the login screen)
let doBeforeVueLoad = app.translationManager.loadLanguages(['en', store.state.currentLanguage], ['local']);

/*
 If a refresh token is still inside the store
 1) Try to refresh the auth tokens
 2) If the tokens were succesfully refreshed: Load all the backend translations from the server
 3) If the tokens were succesfully refreshed: Load server information (version, DSS version, etc)
 4) If the tokens failed to refresh, trigger logout (remove old token data)
 */

if (store.state.authRefreshToken && !loggedOut){
    doBeforeVueLoad = doBeforeVueLoad.then(() => app.authentication.refreshToken()).then((tokenData) => {
        if (tokenData.authToken) {
            return Promise.all([
                app.translationManager.loadLanguages(['en', store.state.currentLanguage]),
                app.store.dispatch('loadServerInfo')
            ]);
        }else{
            store.dispatch('logout')
            return Promise.resolve()
        }
    });
}

doBeforeVueLoad.then(() => {
    const vueApp = new Vue({
        router,
        store,
        apolloProvider,
        vuetify,
        // i18n,
        directives: {Sticky},
        render: h => h(App)
    })

    vueApp.$mount('#app')

    // server poll, used to refresh new tokens if user is inactive
    setInterval(() => {
        if (store.state.authToken) {
            store.dispatch('setLastRefresh', new Date())
            app.knowledgeManager.poll()
        }
    }, 60 * 1000)
})

window.app = app

// app.authentication.startAutoLogout(2000000, 10)

window.store = store;

